class FunnelWidget extends BaseWidget<FunnelResultVM, FunnelConfig> {
    override widgetType = WidgetType.Funnel;
    
    constructor(container: any, tab: WorkbookTab, $reportContent, dashboardWidget: DashboardWidget) {
        super(container, tab, $reportContent, dashboardWidget);
    }

    setConfig(config) {
        this.itemConfig = new FunnelConfig(config);
    }

    setResult(result) {
        let self = this;
        this.result = new FunnelResultVM(result);

        this.result.funnelSettings = {
            dataSource: this.result.dataTable,
            argumentField: this.result.descriptionField !== null ? this.result.descriptionField.index : FunnelResultVM.xArgument as any,
            valueField: this.result?.metric?.index as any,
            palette: 'Soft Pastel',
            legend: ChartService.getLegendOptions(this.itemConfig.legendPosition) as any,
            inverted: ko.computed(function () {
                return self.itemConfig.type() === FunnelTypeEnum.Pyramid;
            }) as any,
            algorithm: ko.computed(function () {
                return self.itemConfig.type() === FunnelTypeEnum.Pyramid ? 'dynamicHeight' : 'dynamicSlope';
            }) as any,
            tooltip: {
                enabled: true,
                customizeTooltip: function (arg) {
                    return { text: `${arg.item.argument}: ${self.formatTooltiValue(arg.value)}` };
                },
            },
            item: {
                border: {
                    visible: true,
                },
            },
            label: {
                visible: this.itemConfig.labelVisibility as any,
                position: this.itemConfig.labelPosition as any,
                backgroundColor: 'none',
                customizeText(e) {
                    if (self.itemConfig.labelShowPercentage()) {
                        return `<span style='font-size: 18px'>${self.formatLabelValue(e.percent)}</span><br/>${e.item.argument}`;
                    }
                    else {
                        return `<span style='font-size: 18px'>${self.formatLabelValue(e.value)}</span><br/>${e.item.argument}`;
                    }
                },
            },
            onItemClick(e) {
                self.onDrillDown(e);
            },
            onInitialized(e) {
                self.result.repaint = function () {
                    e.component.option(self.result.funnelSettings);
                }
            },
        };
    }

    setupSettings() {
        this.createSettingItem(this.itemConfig.type, "type", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.fieldAutoGrouping, "fieldAutoGrouping", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.topBottomType, "topBottomType", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.topBottomValue, "topBottomValue", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.legendPosition, "legendPosition", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.labelVisibility, "labelVisibility", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.labelPosition, "labelPosition", UpdateSettingMode.Automatic);
        this.createSettingItem(this.itemConfig.labelShowPercentage, "labelShowPercentage", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.decimalPlaces, "decimalPlaces", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.format, "format", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.unitFormat, "unitFormat", UpdateSettingMode.Reload);
    }

    repaint() {
        this.result.repaint();
    }

    runSetup() {
        this.setup();
    }

    setup() {
        
    }

    onDrillDown(e: DevExpress.viz.dxFunnel.ItemClickEvent) {
        if (!this.tabOrWidget.drilldownManager.isDrilldownPossible())
            return;

        let data = e.item.data as Array<any>;
        let tabValues: Array<FilterValuesVM> = [];

        tabValues.push({
            name: this.result.field.queryName,
            startCondition: data[this.result.field.index],
            isGroupField: false,
        });

        this.executeDrilldown(tabValues);
    }

    private formatTooltiValue(value: number): string {
        let metric = MappingService.getMetric(this.itemConfig.metric());
        return this.formatValue(value, metric.decimalPlaces, metric.format, LabelFormatEnum.Normal);
    }
    private formatLabelValue(value: number): string {
        let metric = MappingService.getMetric(this.itemConfig.metric());
        let decimalPlaces = this.itemConfig.decimalPlaces() === -1 ? metric?.decimalPlaces || 0 : this.itemConfig.decimalPlaces();
        let format = this.itemConfig.format() === FieldFormatEnum.None ? metric?.format || FieldFormatEnum.Numeric : this.itemConfig.format();

        return this.formatValue(value, decimalPlaces, format, this.itemConfig.unitFormat());
    }
    private formatValue(value: number, decimalPlaces: number, format: FieldFormatEnum, unitFormat: LabelFormatEnum): string {
        let dx = DevExpress as any;
        let largerNumber = labelFormatEnumToString(unitFormat);
        const currencySign = "standard";
        const formatValue = format === FieldFormatEnum.None ? FieldFormatEnum.Numeric : format;

        if (formatValue === FieldFormatEnum.Currency)
            return `${dx.formatHelper.format(value, { style: "currency", currency: this.result?.currencyCode || "USD", currencyDisplay: "narrowSymbol", precision: decimalPlaces, currencySign: currencySign, largerNumber: largerNumber })}`;
        else if (formatValue === FieldFormatEnum.Percentage)
            return `${dx.formatHelper.format(value, { style: "percent", precision: decimalPlaces, currencySign: currencySign })}`;

        return `${dx.formatHelper.format(value, { style: "decimal", precision: decimalPlaces, largerNumber: largerNumber, currencySign: currencySign })}`;
    }
}